<template lang="pug">
.signatures-summary-badge
  .summary-signatures-icon
    icon(name='signature')
  span.summary-signatures-text {{ summaryText }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'SignaturesSummaryBadge',
  components: {
    Icon,
  },
  props: {
    count: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    personal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    summaryText() {
      if (this.total > 0 && this.count === this.total) {
        const key = this.personal
          ? 'modal.envelope.mySignaturesSummaryAll'
          : 'modal.envelope.signaturesSummaryAll';
        return this.$t(key, { total: this.total });
      }
      if (this.count === 0) {
        const key = this.personal
          ? 'modal.envelope.mySignaturesSummaryNone'
          : 'modal.envelope.signaturesSummaryNone';
        return this.$t(key);
      }
      const key = this.personal
        ? 'modal.envelope.mySignaturesSummary'
        : 'modal.envelope.signaturesSummary';
      return this.$t(key, { count: this.count, total: this.total });
    },
  },
};
</script>

<style scoped lang="stylus">
.signatures-summary-badge
  display: flex
  align-items: center
  gap: 0.75rem
  padding: 1rem 1.25rem
  background-color: #E7F0EF
  border: 1px solid rgba(25, 102, 91, .3)
  border-radius: 8px
.summary-signatures-icon
  display: flex
  align-items: center
  justify-content: center
  flex: 0 0 auto
  width: 2.25rem
  height: 2.25rem
  border-radius: 8px
  background-color: #fff
  color: #19665B
.summary-signatures-text
  font-size: 0.85rem
  font-weight: 600
  color: #19665B
</style>
